import styled from 'styled-components';

export const ColumnHeader = styled.div`
  text-align: left;
`;

export const Spacing = styled.div`
  margin-top: 5px;
`;
